module.exports = __webpack_public_path__ + "img/red-trash.1fda9077.svg";